import React, { useContext, useEffect, useState, memo } from "react";
import { Data } from "../App";
import { Glass, Stock, Label, Picks } from "../common/Icon";

// シリーズ内の生地をリスト表示（画像クリックでモーダル起動）
const List = memo(({ data }) => {
  const { setModalCurrent, setModal } = useContext(Data);
  function modalOpen(item) {
    setModalCurrent(item);
    setModal(true);
  }

  if (data.length > 0) {
    return (
      <ul className="list_container">
        {data.map((item, i) => {
          return (
            <li key={i}>
              <div onClick={() => modalOpen(item)}>
                <img
                  src={`/material/images/wave/thumb/${item.code}.jpg`}
                  alt=""
                />
                <Glass />
                <Stock data={item.stock} />
                <Label data={item.label} />
                <Picks data={item.topfabric} />
              </div>
              <Checkbox data={item} />
            </li>
          );
        })}
      </ul>
    );
  }
});

// 生地選択処理（チェックボックス＋ラベル部分）
function Checkbox({ data }) {
  const { filteredList, selectedList, setSelectedList } = useContext(Data);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    selectedList.includes(data) ? setIsChecked(true) : setIsChecked(false);
  }, [data, selectedList, filteredList]);

  function sampleSelect(item) {
    if (selectedList.includes(item)) {
      const removed = selectedList.filter((obj) => obj !== item);
      setSelectedList(removed);
    } else if (selectedList.length < 5) {
      setSelectedList(() => [...selectedList, item]);
    } else {
      alert("選択出来る生地は5枚までです。");
    }
  }

  return (
    <label>
      <input
        type="checkbox"
        style={{ display: "none" }}
        onChange={() => sampleSelect(data)}
      />
      <span
        style={{ backgroundColor: isChecked ? "#4e587f" : "transparent" }}
      ></span>
      <p>
        {data.kiji.split(" ")[0]}
        <small>{data.kiji.split(" ")[1]}</small>
      </p>
    </label>
  );
}

export default List;
